import styled from '../../styles/styledComponents/themeComponents';

export const WarningStyle = styled.p`
  color: #c92a2a;
  font-weight: 700;
  font-size: 14px;
`;
